import {
  ConnectedPosition,
  Overlay,
  OverlayPositionBuilder,
  OverlayRef,
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  inject,
} from '@angular/core';
import { SharedRecipientDetails } from '@compumark/order-management-client';

import { SharedRecipientToolTipComponent } from '../component/shared-recipient-tool-tip/shared-recipient-tool-tip.component';

@Directive({
  selector: '[appSharedRecipientTooltip]',
  standalone: false,
})
export class SharedRecipientTooltipDirective implements OnDestroy {
  private overlay = inject(Overlay);
  private positionBuilder = inject(OverlayPositionBuilder);
  private elementRef = inject(ElementRef);

  @Input() appSharedRecipientTooltip!: SharedRecipientDetails[];

  private overlayRef?: OverlayRef;
  private closeTimer?: number;
  private readonly positions: ConnectedPosition[] = [
    {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
      offsetY: 8,
    },
    {
      originX: 'end',
      originY: 'center',
      overlayX: 'start',
      overlayY: 'center',
      offsetX: 8,
    },
  ];

  @HostListener('mouseenter')
  show(): void {
    this.cancelClose();
    if (this.overlayRef) {
      return;
    }
    const positionStrategy = this.positionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions(this.positions)
      .withViewportMargin(28);

    this.overlayRef = this.overlay?.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
    });

    this.overlayRef.attach(
      new ComponentPortal(SharedRecipientToolTipComponent),
    ).instance.sharedRecipientDetails = this.appSharedRecipientTooltip;

    const overlayEl = this.overlayRef.overlayElement;
    overlayEl.addEventListener('mouseenter', () => this.cancelClose(), {
      passive: true,
    });
    overlayEl.addEventListener('mouseleave', () => this.scheduleClose(), {
      passive: true,
    });
  }

  @HostListener('mouseleave')
  hide(): void {
    this.scheduleClose();
  }

  ngOnDestroy(): void {
    this.overlayRef?.dispose();
    this.overlayRef = undefined;
  }

  private scheduleClose(): void {
    this.cancelClose();
    this.closeTimer = window.setTimeout(() => this.ngOnDestroy(), 150);
  }

  private cancelClose(): void {
    if (this.closeTimer == null) {
      return;
    }
    window.clearTimeout(this.closeTimer);
    this.closeTimer = undefined;
  }
}
